<template>
  <!-- Inizio repeater repeater-->
  <div>
    
      <div class="RepeaterTabellaDettaglio">
        <div class="TabellaDettaglio">
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
              <tr>
                <td class="TDRep">
                  <div class="TRIndex">
                    <div>Reparto</div>
                    <div>{{ this.attivita.Reparto }}</div>
                  </div>
                </td>
                <td class="TDCom">
                  <div class="TRIndex">
                    <div>Comparto</div>
                    <div>{{ this.attivita.Comparto }}</div>
                  </div>
                </td>
                <td class="TDEnt">
                  <div class="TRIndex">
                    <div>Entità</div>
                    <div>{{ this.attivita.DescrizioneEntita }}</div>
                  </div>
                </td>
                <td class="TDAtt">
                  <div class="TRIndex">
                    <div>Attività</div>
                    <div>{{ this.attivita.DescrizioneAttivita }}</div>
                  </div>
                </td>
                <td class="TDNot">
                  <div class="TRIndex">
                    <div>Note intervento</div>
                    <div>{{ this.attivita.NoteIntervento }}</div>
                  </div>
                </td>
                <td class="TDRep">
                  <div class="TRIndex">
                    <div>Esito</div>
                    <div>{{this.attivita.DescrizioneEsito}}</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="ToggleButton">
          <div class="Operazioni Button Iconed Stroked Toggled ExtraSmall" @click="this.openTabs(index, this.attivita.SysChiaveglobale, $event)" :id="'operazioni' + this.index">
            <span>Operazioni/Ricambi</span>
          </div>
        </div>
      </div>
      <div class="TabHolder TabOperazioneRicambi"  style="display:none;"  :id="'tabsPanel' + index">
        <div class="TabButtonBox">
          <div class="TabButton SelectedItem" :id="'lnkOperazioni' + index" @click="this.openTabOperazioni(index)">Operazioni</div>
          <div class="TabButton" :id="'lnkRicambi' + index" @click="this.openTabRicambi(index)">Ricambi</div>
        </div>
        <div class="TabContentBox">
          <div class="TabContent" :id="'tabOperazioni' + index">
            <keep-alive>
              <component
              :is="gridOperazioni"
              :chiaveAttivita="this.attivita.SysChiaveglobale"
              >
              </component>
            </keep-alive>
          </div>
          <div class="TabContent"  style="display:none;" :id="'tabRicambi' + index">

            <keep-alive>
            <component
              :is="gridRicambi"
              :chiaveAttivita="this.attivita.SysChiaveglobale"
              :attivita="this.attivita"
            ></component>
            </keep-alive>

          </div>
        </div>
      </div>
      <!-- Fine repeater repeater-->
  </div>
</template>
<script>

import GrigliaOperazioniStorico from "@/components/GrigliaOperazioniStorico.vue";
import GrigliaRicambiStorico from "@/components/GrigliaRicambiStorico.vue";
import {apiMixin} from "/mixin.js";
import EmptyComponent from "@/components/EmptyComponent.vue";

export default {
    name: "PannDettInterventiStoricoRiga",
    props:{       
        chiaveIntervento: String,
        attivita: Object,
        index: Number,
        idCont: String
    },
    components:{
      GrigliaOperazioniStorico,
      GrigliaRicambiStorico,            
      EmptyComponent
    },
    data(){
      return {       
        listaRicambi: [],
        attivitaEseguita: false,
        noteInterventoAttivita: "",
        showGridOperazioni: false,
        showGridRicambi: false
      }
    },
    computed:{
      gridOperazioni(){       
        return this.showGridOperazioni ? "GrigliaOperazioniStorico" : "EmptyComponent";         
      },
      gridRicambi(){        
        return this.showGridRicambi ? "GrigliaRicambiStorico" : "EmptyComponent";               
      }
    },
    mixins:[apiMixin],
    methods:{    
      openTabs: function(index, chiaveAttivita, e){
        
        var el = e.srcElement.parentElement;
        if(!($("#"+this.idCont+"#tabsPanel"+index).is(":visible"))){

          this.showGridOperazioni = true;
        }
        else{
          this.showGridOperazioni = false;
        }
      
        $("#"+this.idCont+" #tabsPanel"+index).slideToggle('fast');      
        $(el).toggleClass('Open').toggleClass('Close');
        $(el).parent().parent().toggleClass('PannelloOpen');
      
      },
      openTabOperazioni: function(index){

        this.showGridOperazioni = true;
        this.showGridRicambi = false;
        $("#"+this.idCont+" #lnkOperazioni" + index).addClass("SelectedItem");
        $("#"+this.idCont+" #lnkRicambi" + index).removeClass("SelectedItem");
      
        $("#"+this.idCont+" #tabRicambi" + index).fadeOut(0);
        $("#"+this.idCont+" #tabOperazioni" + index).fadeIn('fast'); 
      },
      openTabRicambi: function(index){

        this.showGridOperazioni = false;
        this.showGridRicambi = true;

        $("#"+this.idCont+" #lnkOperazioni" + index).removeClass("SelectedItem");
        $("#"+this.idCont+" #lnkRicambi" + index).addClass("SelectedItem");

        $("#"+this.idCont+" #tabRicambi" + index).fadeIn('fast');
        $("#"+this.idCont+" #tabOperazioni" + index).fadeOut(0);
      } 
    
    }    
}
</script>